(function () {
  const header = document.querySelector('[data-phead]');
  if (!header) return;

  const toggleBtn = header.querySelector('[data-phead-toggle]');
  const overlay = header.querySelector('[data-phead-overlay]');
  const closeEls = header.querySelectorAll('[data-phead-close]');
  function setOpen(open) {
    const sbw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--phead-sbw', open ? `${sbw}px` : '0px');

    header.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('phead-lock', open);

    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (overlay) overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
  }



  toggleBtn?.addEventListener('click', () => {
    setOpen(!header.classList.contains('is-open'));
  });

  // Clicking empty overlay background closes
  overlay?.addEventListener('click', (e) => {
    if (e.target === overlay) setOpen(false);
  });

  closeEls.forEach((el) => {
    el.addEventListener('click', () => setOpen(false));
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setOpen(false);
  });
})();
